import { useMemo } from 'react';
import Fields from '../Fields';
import { useAuth } from '../../../../utils/Auth';
import PostSurveyOptions from './PostSurveyOptions';
import styles from './Survey.module.css';

const Survey = (props) => {
    const { reference } = props;
    const { qr_data } = useAuth();

    const fields = useMemo(() => {
        const baseFields = qr_data?.data?.survey?.fields?.length
            ? qr_data.data.survey.fields
            : [{ id: 'date', name: 'Timestamp', archived: false, show: true, type: 'date', required: true }];

        const filteredFields = baseFields.filter(field => field.type !== 'date');

        return filteredFields.sort((a,b) => a.archived - b.archived);
    },[qr_data]);

    // Store the original fields when component first mounts with data
    const originalFields = useMemo(() => {
        if (reference === 'new') return [];
        const baseFields = qr_data?.data?.survey?.fields?.length
            ? qr_data.data.survey.fields
            : [];
        return baseFields.filter(field => field.type !== 'date');
    }, [reference]);

    return (
        <div className={styles.container}>
            <Fields fields={fields} reference={reference} originalFields={originalFields} />
            <PostSurveyOptions />
        </div>
    );
};

export default Survey;